import { observer } from 'mobx-react';
import * as React from 'react';
import { Tooltip, PlacesType } from 'react-tooltip';
import { TranslationsState } from '@execonline-inc/translations';
import clickOutsideStore from '../../ClickOutsideStore';
import { translation, TPlainTextKey } from '../../Translations';

import type { JSX } from 'react';

type State = {
  isOpen: boolean;
};

interface Props {
  tooltipId: string;
  className?: string;
  tooltipIcon: JSX.Element;
  children: JSX.Element;
  place?: PlacesType;
  backgroundColor?: string;
  ariaLabel?: TPlainTextKey;
  ariaLabelOverride?: string;
  translationsState?: TranslationsState;
}

class ClickableTooltip extends React.Component<Props> {
  state: State = {
    isOpen: false,
  };

  tooltipRef: React.RefObject<HTMLDivElement | null> = React.createRef();

  close = () => this.setState({ isOpen: false });

  toggle = () => {
    const { isOpen } = this.state;
    clickOutsideStore.addListener({ ref: this.tooltipRef, callback: this.close });
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const {
      tooltipId,
      tooltipIcon,
      children,
      className,
      place,
      backgroundColor,
      ariaLabel,
      ariaLabelOverride,
      translationsState,
    } = this.props;
    const buttonAriaLabel =
      ariaLabelOverride ||
      (ariaLabel && translationsState ? translation(ariaLabel)(translationsState) : ariaLabel);
    return (
      <div className={className || 'flex items-center'} ref={this.tooltipRef}>
        <button
          className="flex cursor-pointer bg-transparent p-0 text-xs text-inherit"
          data-tooltip-id={tooltipId}
          onClick={() => this.toggle()}
          aria-label={buttonAriaLabel}
        >
          {tooltipIcon}
        </button>
        <Tooltip
          id={tooltipId}
          place={place || 'bottom'}
          style={{
            borderRadius: '6px',
            width: '148px',
            zIndex: 10,
            backgroundColor: backgroundColor,
            padding: '5px 8px',
          }}
          clickable
          isOpen={this.state.isOpen}
          opacity={1}
        >
          <div className="p-0 text-xs">{children}</div>
        </Tooltip>
      </div>
    );
  }
}

export default observer(ClickableTooltip);
